export default __webpack_public_path__ + "static/media/login-visual4.1823ffc7.jpg";